<template>
  <div style="background: #999">
    <div class="mobileHead" id="head">
      <img
        src="@/assets/images/logo.png"
        alt=""
        class="logo"
        @click="  backEvent"
      />
      <img
        src="@/assets/images/icon_close.png"
        alt=""
        class="menu"
        @click="closeEvent"
      />
    </div>
    <div class="nav">
      <ul>
        <li v-for="(item, i) in navList" :key="i" @click="chooseMenu(item)">
          <span></span>
          {{ item.label }}
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      navList: [
        {
          path: "/",
          label: "首页",
        },
        {
          path: "/solution",
          label: "解决方案",
        },
        {
          path: "/caseAndUse",
          label: "案例及应用",
        },
        {
          path: "/newsCenter",
          label: "新闻中心",
        },
        {
          path: "/aboutUs",
          label: "关于我们",
        },
      ],
    };
  },
  methods: {
    closeEvent() {
      this.$router.go(-1);
    },
    chooseMenu(item) {
      this.$router.push({
        path: item.path,
      });
    },
    backEvent() {
      this.$router.push({ path: "/" });
    },
  },
};
</script>

<style lang="scss" scoped>
.mobileHead {
  width: 100%;
  height: 90px;
  background: #fff;
  display: flex;
  justify-content: space-between;
  align-items: center;
  .logo {
    width: 166px;
    height: 44px;
    margin-left: 40px;
  }
  .menu {
    width: 38px;
    height: 38px;
    margin-right: 40px;
  }
}
.nav {
  background: #fff;
  ul {
    padding: 30px;
    li {
      height: 80px;
      line-height: 80px;
      list-style-type: none;
      text-align: left;
      border-bottom: 1px solid #999;
      span {
        width: 10px;
        height: 10px;
        display: inline-block;
        background: #3660d9;
        border-radius: 50%;
        margin-right: 10px;
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/publicCom/mobileMenu.vue